import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppConstants } from '../constants/app-constants';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class AuthService {
    constructor(public userCacheService: UserCacheService) { }
    // ...
    private jwtHelper = new JwtHelperService();
    public isAuthenticated(): boolean {
        // const token = localStorage.getItem(AppConstants.TOKEN) ?? '';
        const token = this.getCookie(AppConstants.TOKEN) ?? '';
        // Check whether the token is expired and return
        // true or false
        return !this.jwtHelper.isTokenExpired(token);
        // return (token);
    }

    getCookie(name: string) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}
